export default {
  // ACCOUNT & PLAN SETTINGS
  "account-settings_page-title": "Account & Plan Settings",
  "___account-settings_title_personal-settings": "",
  "___account-settings_title_hsa-settings": "",
  "___account-settings_title_veba-settings": "",
  "___account-settings_title_fsa-settings": "",
  "___account-settings_title_hra-settings": "",
  "___account--settings_title_account-status": "",
  "___account-settings_label_on-hold": "",
  "___account-settings_label_active": "",
  "___account-settings_action_release-hold": "",
  "___account-settings_action_set-hold": "",
  "account-settings_action_change-hsa": "Change type",
  "account-settings_action_change-veba": "Change type",
  "account-settings_title_hsa-plan": "HSA Type",
  "account-settings_title_veba-plan": "VEBA Type",
  "account-settings_link_hsa-type-info": "View information",
  "___account-settings_title_health-plan-coverage": "",
  "account-settings_title_hsa-beneficiaries": "HSA Beneficiaries",
  "account-settings_title_veba-beneficiaries": "VEBA Beneficiaries",
  "___account-settings_action_view-beneficiaries": "",
  "___account-settings_label_beneficiary": "",
  "___account-settings_label_beneficiaries": "",
  "___account-settings_label_account-number": "",
  "account-settings_action_edit-plan-coverage": "Edit Plan Coverage",

  // PERSONAL SETTINGS
  "personal-settings_text_carrier": "Carrier: %carrier%",
  "___personal-settings_title_payment-banking": "",
  "___personal-settings_title_providers": "",
  "personal-settings_text_release-authorizations":
    "%ariDesigneesQuantity% ARI Designees",
  "___personal-settings_action_manage-payment-banking": "",
  "___personal-settings_action_learn-about-payment-banking": "",
  "___personal-settings_action_manage-providers": "",
  "___personal-settings_title_communications": "",
  "___personal-settings_action_manage-communication": "",
  "___personal-settings_title_release-authorization":
    "Release Authorization (ARI)",
  "personal-settings_action_add-ari": "Add a Release",
  "___personal-settings_text_last-updated": "",
  "___personal-settings_action_learn-about-ari": "",
  "___personal-settings_title_personal-information": "",
  "personal-settings_action_edit-personal-information": "Edit",
  "___personal-settings_action_manage-hsa-beneficiaries": "",
  "___personal-settings_label_bank-account": "",
  "___personal-settings_label_bank-accounts": "",
  "___personal-settings_label_provider": "",
  "___personal-settings_label_providers": "",
  "___personal-settings_label_ari-designee": "",
  "___personal-settings_label_ari-designees": "",

  // PAYMENT & BANKING
  "payment-banking_page-title": "Payment & Banking",
  "___payment-banking_menu-item_payment-method": "",
  "___payment-banking_menu-item_bank-accounts": "",

  // BANK ACCOUNTS
  "bank-accounts_page-title": "Bank Accounts",
  "bank-accounts_page-description":
    "These bank accounts are used for contributions and reimbursements. Automatic reimbursements will be deposited to your primary account.",
  "___bank-accounts_title_related": "",
  "bank-accounts_action_add-bank-account": "Add Bank",
  "bank-accounts_action_make-primary-bank-account": "Make Primary Account",
  "bank-accounts_action_remove-bank-account": "Delete",
  "___bank-accounts_label_primary-account": "",
  "___bank-accounts_label_checking": "",
  "___bank-accounts_label_savings": "",
  "___bank-accounts_label_bank-name": "",
  "___bank-accounts_label_account-type": "",
  "___bank-accounts_label_account-number": "",
  "___bank-accounts_label_routing-number": "",

  // PAYMENT METHODS EXPANDER
  "payment-methods_page-title": "Payment Method",
  "payment-methods_page-description":
    "Your payment method determines how you pay for services from your health care expenses account(s). Lost or stolen card? Call %groupTollFreePhone%.",
  "payment-methods_title_debit-card": "Debit Card",
  "payment-methods_title_automatic-claim-submission":
    "Automatic Claim Submission",
  "payment-methods_label_current-method": "Your Current Payment Method",

  // DEBIT CARD
  "debit-card_text_option-description":
    "Debit cards allow you to pay for eligible service just like a traditional credit card that draws from your medical account. This is the payment method preferred by most account holders.",
  "debit-card_text_switch-to-debit-card-warning":
    "Switching to Debit Card will opt you out of Automatic Claim Submission.",
  "debit-card_action_cancel-card": "Delete",
  "debit-card_action_request-card": "Request Card",
  "debit-card_action_add-card": "Add Card",
  "debit-card_action_switch-to-debit-card": "Switch and Get a Debit Card",
  "___debit-card_label_primary-card-holder": "",
  "___debit-card_label_spouse": "",
  "___debit-card_label_child": "",
  "debit-card_label_card-for-accounts": "Card for Accounts:",
  "___debit-card_label_requested": "",
  "debit-card_text_support-number": "%groupTollFreePhone%",

  // CROSSOVER
  "crossover_title_automatically-submit-these-claims":
    "Automatically submit these claims:",
  "crossover_text_option-description_has-primary":
    "Automatic Claim Submission (Crossover) is an electronic connection between your health plan and medical spending accounts that allow your health plan to automatically submit claims for reimbursement. Click to switch  to automatic claims submission. Switching to Automatic Claims Submission will opt you out of Debit Card. This cannot be undone.",
  "crossover_text_option-description_no-primary":
    "Automatic Claim Submission (Crossover) is an electronic connection between your health plan and medical spending accounts that allow your health plan to automatically submit claims for reimbursement. Click to manage your crossover elections.",
  ___crossover_title_medical: "",
  "crossover_text_medical-description":
    "Get reimbursed for out-of-pocket medical expenses",
  ___crossover_title_ptp: "",
  "crossover_text_ptp-description":
    "Send payment directly to your medical providers",
  ___crossover_title_dental: "",
  "crossover_text_dental-description":
    "Get reimbursed for out-of-pocket dental expenses",
  "___crossover_action_make-changes": "Manage",
  "crossover_action_switch-to-crossover":
    "Switch to Automatic Claim Submission",
  crossover_text_enrolled: "You are enrolled in the following:",
  "crossover_text_not-enrolled": "You are currently not enrolled",
  "crossover_text_switch-to-crossover-warning":
    "Switching to Automatic Claim Submission will opt you out of Debit Card.",

  // PROVIDERS
  "providers_page-title": "Manage Providers",
  ___providers_title_providers: "",
  "providers_page-description":
    "Here you can add, edit, or delete your providers on file.",
  ___providers_title_related: "",
  "___providers_action_add-provider": "",
  "___providers_label_account-number": "",
  "providers_action_pay-bill": "Pay a Bill",
  "___providers_action_edit-provider": "",
  "providers_action_remove-provider": "Delete",
  "providers_text_no-providers":
    "You do not currently have any providers on file for claim payment. Please click the Add Provider button to initiate this process.",

  // VIEW ACCOUNT NUMBER
  "account-settings_title_view-account-number": "View Full Account Number",
  "account-settings_action_view-account-number": "View Full Account Number",
  "account-settings_view-account-number_header": "View Account Number",
  "account-settings_view-account-number_description":
    "We have sent you a temporary token. To view your account number, enter the token.",
  "___account-settings_view-account-number_title_confirm-close": "",
  "___account-settings_view-account-number_text_confirm-close": "",
  "___account-settings_view-account-number_action_confirm-close_cancel": "",
  "___account-settings_view-account-number_action_confirm-close_confirm": "",

  // COMMUNICATIONS
  "communications_page-title": "Communications",
  "___communications_page-title": "",
  "communications-header-subtext":
    "Indicate how you like to receive important information about your account and activity.",
  "___communications_your-contact-info": "",
  "communications_form_how-to-receive":
    "How would you like to receive your communications?",
  "communications_form_note":
    "Note: We are pausing our SMS service while we work to improve our communication capabilities.",
  "communications_description_suppressed-edit-message":
    "Please update your communication preferences on %customerServiceURL%.",
  "communications_form_edit-preferences": "Edit Preferences",
  "communications_text_please-note":
    "Please note: There may be instances in which we are required by law to communicate information to you. Your communication preference settings will not affect those required circumstances.",
  "communications-form-textalert-message": 
    "Text Alerts: Can we send account alerts or other non-marketing text messages to your mobile phone number?",
  "communications-descriptionsuppressed-nophonenumber":
    "You haven't added a mobile number.",
  "communications-addmobilenumber-button": "Add a Mobile Phone Number",
  "communications-form-editinfo-label": "Edit Info",
};
